/**
 * Go to the checkout cart page.
 */
export const toCheckoutCart = '/checkout?step=cart'

/**
 * Go to the checkout confirmation page.
 */
export const toCheckoutConfirmation = '/checkout/confirmation'

/**
 * Go to the checkout screen.
 */
export const toCheckout = '/checkout'
